export default [{
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_1.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_2.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_3.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_4.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_5.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_6.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_7.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_8.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_9.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_10.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_11.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_12.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_13.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_14.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_15.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_16.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_17.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_18.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_19.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_20.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_21.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_22.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_23.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_24.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_25.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_26.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_27.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_28.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_29.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_30.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_31.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_32.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_33.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_34.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_35.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_36.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_37.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_38.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_39.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_40.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_41.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_42.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_43.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/4jie/4jie_44.jpg"
}]


// WEBPACK FOOTER //
// ./src/pages/history/jie4.js